"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.REMOVE_FROM_WISH_LIST = exports.GET_WISH_LIST_SKU_IDS = exports.GET_WISH_LIST = exports.ADD_TO_WISH_LIST = void 0;
const ADD_TO_WISH_LIST = exports.ADD_TO_WISH_LIST = 'addToWishList';
const GET_WISH_LIST = exports.GET_WISH_LIST = 'getWishList';
const REMOVE_FROM_WISH_LIST = exports.REMOVE_FROM_WISH_LIST = 'removeFromWishList';
const GET_WISH_LIST_SKU_IDS = exports.GET_WISH_LIST_SKU_IDS = 'getWishListSkuIDs';